import React from 'react'
import injectSheet from 'react-jss'
import classNames from 'classnames'

import { styles } from './Styles/ImageModule.Style'

type Props = {
  classes: { [string]: string },
  image: string
}

class ImageModule extends React.Component {
  props: Props

  render () {
    const { classes, image } = this.props
    return (
      <div className={classes.container}>
        <div>
          <img
            className='col-xs-10 col-xs-offset-1 col-sm-8 col-sm-offset-2'
            src={image}
            alt={'preview'} />
        </div>
      </div>
    )
  }
}

export default injectSheet(styles)(ImageModule)



// WEBPACK FOOTER //
// ./src/components/ImageModule.jsx